export function DpoLink({ testId }: { testId: string }) {
  return (
    <a data-testid={testId} href="mailto:atelie@gepeto.life" className="text-emerald-400 underline-offset-4 hover:underline">
      atelie@gepeto.life
    </a>
  );
}
